export default {
  getData: (state) => state.settings,
  isFetching: (state) => state.settings.isFetching,
};
